/**
 * Registro de «este error ya se le mostró al usuario» — la pieza que permite
 * que la red de seguridad global (mutationErrorHandler) conviva con los ~280
 * manejos locales sin duplicar avisos.
 *
 * 🔴 Por qué existe: los callbacks pasados en `mutate(vars, { onError })` viven
 * en un WeakMap PRIVADO del MutationObserver de TanStack (verificado en
 * query-core 5.62.3), así que el `MutationCache.onError` NO puede saber si el
 * llamador maneja el error. La señal se construye del otro lado: quien muestra
 * un error lo marca acá, y la red —que difiere su aviso unos milisegundos—
 * solo dispara si nadie marcó nada.
 *
 * Dos señales, porque los manejos locales tienen dos formas:
 *  - La MARCA por error (WeakSet): la dejan los extractores compartidos
 *    (`extractErrorMessage`, `getApiErrorMessage`) al leer el mensaje.
 *  - El HEARTBEAT: lo dejan los toasts de error (locales y globales), para los
 *    handlers de mensaje fijo que nunca tocan el objeto del error
 *    (`onError: () => toast.error('No se pudo…')`).
 */

const mostrados = new WeakSet<object>()
let ultimoToastDeError = 0

export function marcarErrorMostrado(e: unknown): void {
  if (e && typeof e === 'object') mostrados.add(e)
}

export function errorYaMostrado(e: unknown): boolean {
  return !!e && typeof e === 'object' && mostrados.has(e as object)
}

/** La llaman los sistemas de toast al mostrar un error (heartbeat). */
export function registrarToastDeError(): void {
  ultimoToastDeError = Date.now()
}

/** ¿Se mostró algún toast de error desde el instante `desde`? */
export function huboToastDeErrorDesde(desde: number): boolean {
  return ultimoToastDeError >= desde
}
